import React, {Component} from 'react';
import CalendarRows from "./../components/CalendarRight/CalendarRows";
import {connect} from "react-redux";

class CalendarRowsContainer extends Component {
  render() {
    return (
      <CalendarRows datos={this.props.store} />
    );
  }
}

const mapStateToProps = store => ({
  store
});

export default connect(mapStateToProps, null)(CalendarRowsContainer);
